import React from 'react'

const InfoPortul = () => {
  return <div style={{ height: '1000px' }}>InfoPortul</div>
}

export default InfoPortul
